import React, { Component } from 'react';
import _ from 'lodash';
import Validator from 'validatorjs';
import { Button, Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';
import NominaPercepcionHorasExtraManager from './NominaPercepcionHorasExtraManager';
import NominaCatalogoManager from '../../../../catalogs/managers/NominaCatalogoManager';

class NominaPercepcionForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      validator: new Validator({}, this.rules),
    };
  }

  get rules() {
    const isAccionesOTitulosRequired = this.isAccionesOTitulosRequired();

    return {
      TipoPercepcion: ['required', 'string'],
      Clave: ['required', 'string', 'min:3', 'max:15', 'regex:/^[^|]{3,15}$/'],
      Concepto: ['required', 'string', 'min:1', 'max:100', 'regex:/^[^|]{1,100}$/'],
      ImporteGravado: ['required', 'decimal:2', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
      ImporteExento: ['required', 'decimal:2', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
      ValorMercado: [isAccionesOTitulosRequired ? 'required' : 'decimal:6', 'decimal:6', 'min:0.000001'],
      PrecioAlOtorgarse: [isAccionesOTitulosRequired ? 'required' : 'decimal:6', 'decimal:6', 'min:0.000001'],
    };
  }

  componentDidMount() {
    this.fillCatalogs();
  }

  async componentDidUpdate() {
    const { data } = this.props;

    if (!!data) {
      const validator = this.validate({ ...data });

      this.setState({
        data: { ...data },
        isValid: validator.passes(),
      });
    }
  }

  fillCatalogs = async () => {
    if (!this.state.catalogos) {
      const values = await NominaCatalogoManager.get('c_nom_tipo_percepcion');

      if (!!values) {
        let catalogos = {};

        const sorted = _.sortBy(
          values.map((item) => {
            return {
              label: `${item.descripcion} (${item.tipo})`,
              value: item.tipo,
            };
          }),
          'value'
        );

        catalogos.tipoPercepcion = sorted;

        this.setState({
          catalogos,
        });
      }
    }
  };

  validate = (data) => {
    const validator = new Validator(data, this.rules);

    validator.check();

    return validator;
  };

  handleOnChange = (values) => {
    const data = {
      ...this.state.data,
      ...values,
    };

    const validator = this.validate(data);

    this.setState({
      data,
      validator,
      horas_extra: data.TipoPercepcion === '019',
      isValid: validator.passes(),
    });
  };

  handleOnAdd = () => {
    this.props.onAdd(this.state.data);

    this.setState({
      isValid: false,
      horas_extra: false,
      data: {},
    });
  };

  handleOnHorasExtraChange = (data) => {
    this.setState({
      data: {
        ...this.state.data,
        HorasExtra: data,
      },
    });
  };

  isAccionesOTitulosRequired = () => {
    return this.state.data?.TipoPercepcion === '045'; // "045" (Ingresos en acciones o títulos valor que representan bienes)
  };

  isHorasExtraRequired = () => {
    return this.state.data.TipoPercepcion === '019'; // "019" (Horas extra)
  };

  render() {
    const rules = this.rules;
    const { isValid, horas_extra, data, catalogos = {} } = this.state;
    const isHorasExtraRequired = this.isHorasExtraRequired();
    const isAccionesOTitulosRequired = this.isAccionesOTitulosRequired();

    return (
      <>
        <Row className="pb-2">
          <Col>
            <FormControl
              type="ahead"
              label="Tipo Percepción"
              id="TipoPercepcion"
              name="TipoPercepcion"
              help=""
              value={data.TipoPercepcion}
              placeholder={data.TipoPercepcion}
              options={catalogos.tipoPercepcion}
              rules={rules.TipoPercepcion}
              onChange={this.handleOnChange}
            />
          </Col>
        </Row>

        <Row>
          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Clave"
              name="Clave"
              placeholder=""
              help=""
              minLength="3"
              maxLength="15"
              rules={rules.Clave}
              value={data.Clave}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Concepto"
              name="Concepto"
              placeholder=""
              help=""
              minLength="1"
              maxLength="100"
              rules={rules.Concepto}
              value={data.Concepto}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="number"
              label="Importe Gravado"
              name="ImporteGravado"
              placeholder=""
              help=""
              min="0"
              rules={rules.ImporteGravado}
              value={data.ImporteGravado}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="number"
              label="Importe Exento"
              name="ImporteExento"
              placeholder=""
              help=""
              min="0"
              rules={rules.ImporteExento}
              value={data.ImporteExento}
              onChange={this.handleOnChange}
            />
          </Col>
        </Row>

        {!!isAccionesOTitulosRequired && (
          <>
            <Row>
              <Col>
                <strong>Acciones o títulos</strong>
              </Col>
            </Row>

            <Row>
              <Col
                sm
                md={4}
              >
                <FormControl
                  type="number"
                  label="Valor Mercado"
                  name="ValorMercado"
                  placeholder=""
                  help=""
                  min="0"
                  rules={rules.ValorMercado}
                  value={data.ValorMercado}
                  onChange={this.handleOnChange}
                />
              </Col>

              <Col
                sm
                md={4}
              >
                <FormControl
                  type="number"
                  label="Precio Al Otorgarse"
                  name="PrecioAlOtorgarse"
                  placeholder=""
                  help=""
                  min="0"
                  rules={rules.PrecioAlOtorgarse}
                  value={data.PrecioAlOtorgarse}
                  onChange={this.handleOnChange}
                />
              </Col>
            </Row>
          </>
        )}

        {!!isHorasExtraRequired && (
          <NominaPercepcionHorasExtraManager
            data={data}
            onChange={this.handleOnHorasExtraChange}
          />
        )}

        <Row className="pt-3">
          <Col className="text-right">
            <Button
              variant="secondary"
              disabled={!isValid || (!!horas_extra && !data.HorasExtra)}
              onClick={this.handleOnAdd}
            >
              Agregar percepción
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}

export default NominaPercepcionForm;
